export const COMMERCE_HOST = "commerce.dev.reviewed.co.kr"

/** Opt-in build; an accidental flag on the production hostname must stay inert. */
export function isCommercePreview(env: Record<string, string | undefined> = process.env) {
  if (env.COMMERCE_PREVIEW !== "1") return false
  try {
    const url = new URL(env.BASE_URL || env.NEXT_PUBLIC_BASE_URL || "")
    return (url.hostname === COMMERCE_HOST && url.protocol === "https:") || (env.NODE_ENV !== "production" && ["localhost", "127.0.0.1"].includes(url.hostname))
  } catch {
    return false
  }
}
